import {defaultHandlerCatch, defaultHandlerResolver, photolabTask} from "./helpers";
import {PhotolabTaskBuilder} from "@vicman-wi/photolab-api-js";

function templateTask(processing, creative) {
  const maskFileUrl = processing.maskFile ? processing.maskFile.url : "";
  const taskConfig = new PhotolabTaskBuilder()
    .setLanguage(processing.language)
    .addCollageMethod({template_name: "skeleton_process"})
    .addImage({
      url: processing.file.url,
      rect: "",
      rotation: 0,
      flip: 0,
      altBody: maskFileUrl
    })
    .build();

  return photolabTask(creative, "template", taskConfig);
}

/**
 * @param {Processing} processing
 * @param {Creative} creative
 */
export default (processing, creative) => {
  return new Promise((resolve, reject) => {
    templateTask(processing, creative)
      .then((taskResult) => {
        creative.markAsProcessed({
          humans: taskResult.humans?.items,
          originalSize: taskResult.originalSize,
        });
      })
      .then(defaultHandlerResolver(creative, resolve))
      .catch(defaultHandlerCatch(creative, reject));
  });
}
